import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/EXIFTOOL/EXIFTOOL_01.png";
import Img_Two from "./../../../../sources/imgs/EXIFTOOL/EXIFTOOL_02.png";
import Img_Three from "./../../../../sources/imgs/EXIFTOOL/EXIFTOOL_03.png";
import Img_Four from "./../../../../sources/imgs/EXIFTOOL/EXIFTOOL_04.png";
import Img_Five from "./../../../../sources/imgs/EXIFTOOL/EXIFTOOL_05.png";
import Img_Six from "./../../../../sources/imgs/EXIFTOOL/EXIFTOOL_06.png";
import Img_Seven from "./../../../../sources/imgs/EXIFTOOL/EXIFTOOL_07.png";
import Img_Eight from "./../../../../sources/imgs/EXIFTOOL/EXIFTOOL_08.png";
import Img_Nine from "./../../../../sources/imgs/EXIFTOOL/EXIFTOOL_09.png";
import Img_Ten from "./../../../../sources/imgs/EXIFTOOL/EXIFTOOL_10.png";
import Img_Eleven from "../../../../sources/imgs/EXIFTOOL/EXIFTOOL_11.png";
import Img_Twelve from "../../../../sources/imgs/EXIFTOOL/EXIFTOOL_12.png";
import Img_Thirteen from "../../../../sources/imgs/EXIFTOOL/EXIFTOOL_13.png";
import Img_Fourteen from "../../../../sources/imgs/EXIFTOOL/EXIFTOOL_14.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function EXIFTOOL (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> EXIFTOOL.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Introducción a EXIFTOOL.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <i className="span-yellow">ExifTool</i> es una <i className="span-blue">herramienta</i> en <span className="span-white">línea de comandos</span> escrita en <span className="span-pink">Perl</span>, ampliamente utilizada para el <span className="span-blue">análisis</span>, <span className="span-blue">edición</span> y <span className="span-blue">manipulación de metadatos</span> en <span className="span-white">archivos</span>.
            </p>

            <p>
                Los <span className="span-pink">metadatos</span> son <span className="span-white">información adicional</span> que contienen los <span className="span-white">archivos</span>, como la <i className="span-blue">fecha de creación</i>, el <i className="span-blue">modelo de cámara</i>, la <i className="span-blue">ubicación GPS</i>, el <i className="span-blue">autor</i> o incluso <i className="span-blue">información de software</i>.
            </p>

            <p>
                En el ámbito de la <b className="span-yellow">ciberseguridad</b> y el análisis <span className="span-white">forense digital</span>, <i className="span-yellow">ExifTool</i> es muy útil porque permite descubrir <span className="span-white">información sensible oculta</span> en <span className="span-blue">fotografías</span>, <span className="span-blue">documentos</span> o <span className="span-blue">ficheros multimedia</span>, la cual puede servir como evidencia en una investigación.
            </p>

            <p>
                <i className="span-yellow">ExifTool</i> se conoce mucho por su uso en <span className="span-white">fotografías</span>, pero en realidad es una herramienta multiformato que soporta más de <i className="span-white">200 tipos de archivos</i>.
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <b className="span-pink">Imágenes:</b> <i className="span-white">JPEG, PNG, TIFF, GIF, BMP, HEIC, RAW (CR2, NEF, ARW, etc.).</i>
                    </p>
                </li>

                <li>
                    <p>
                        <b className="span-pink">Vídeos:</b> <i className="span-white">MP4, AVI, MOV, MKV, FLV, WMV…</i>
                    </p>
                </li>
                <li>
                    <p>
                        <b className="span-pink">Audio:</b> <i className="span-white">MP3, FLAC, WAV, M4A, OGG…</i>
                    </p>
                </li>
                <li>
                    <p>
                        <b className="span-pink">Documentos:</b> <i className="span-white">PDF, DOCX, PPTX, ODT, etc.</i>
                    </p>
                </li>
                <li>
                    <p>
                        <b className="span-pink">Archivos comprimidos:</b> <i className="span-white">ZIP, GZIP, RAR…</i>
                    </p>
                </li>
                <li>
                    <p>
                        <b className="span-pink">Otros formatos especiales:</b> <i className="span-white">archivos de metadatos XMP, JSON, XML, entre otros.</i>
                    </p>
                </li>
            </ul>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Instalación de EXIFTOOL.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
               <i className="span-yellow">Kali Linux</i> ya incluye <i className="span-yellow">ExifTool</i> en la mayoría de sus <span className="span-white">versiones</span>, pero si <span className="span-pink">NO</span> estuviera disponible, se puede <span className="span-pink">instalar</span> de manera sencilla desde los <span className="span-white">repositorios oficiales</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt update"
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt install libimage-exiftool-perl -y"
            />

            <p>
                Tal como se muestra en la <span className="span-white">imagen</span>:
            </p>

            <Img
                img = {Img_One}
                alt = {"Imagen 1. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"1. Comando de instalacion de EXIFTOOL."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Instalación de EXIFTOOL en Windows o MacOS.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Si se desea instalar <i className="span-yellow">ExifTool</i> en SO <b className="span-blue">Windows</b> o <b className="span-blue">MacOS</b>, se puede <span className="span-pink">descargar</span> el ejecutable <i className="span-white">.exe</i>, desde la <span className="span-white">página oficial</span>: <a className="span-white" href="https://exiftool.org">
                    <span className="span-white">https://exiftool.org</span>
                </a>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Visualización de versión de EXIFTOOL.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Una vez <span className="span-white">instalado</span>, verificamos la <span className="span-white">versión</span> con:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "exiftool -ver"
            />

            <p>
                <span className="span-white">Visualizando</span>:
            </p>

            <Img
                img = {Img_Two}
                alt = {"Imagen 2. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"2. Comando para visualizar versión de EXIFTOOL."}
            />

            <p>
                <b className="span-yellow">Nota:</b> Si devuelve un <span className="span-white">número</span> <i className="span-white">(por ejemplo, 12.76)</i>, significa que la <span className="span-pink">instalación</span> fue <span className="span-white">exitosa</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Uso básico de EXIFTOOL.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                La <span className="span-white">sintaxis</span> general de <i className="span-yellow">ExifTool</i> es la siguiente:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "exiftool <opciones> <nombre-archivo>"
            />

            <p>
                Cuando se <span className="span-pink">ejecuta</span> sin opciones, la <span className="span-white">herramienta</span> muestra todos los <span className="span-pink">metadatos</span> del <span className="span-white">archivo</span>.
            </p>

            <p>
                Por <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "exiftool imagen.jpg"
            />

            <p>
                <span className="span-white">Visualizando</span>:
            </p>

            <Img
                img = {Img_Three}
                alt = {"Imagen 3. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"3. Comando básico de EXIFTOOL."}
            />

            <p>
                Esto <span className="span-pink">devolverá</span> una <span className="span-white">lista con información</span> como la <i className="span-blue">fecha de creación</i>, el <i className="span-blue">modelo de cámara</i>, la <i className="span-blue">resolución</i>, la <i className="span-blue">miniatura incrustada</i> y hasta <i className="span-blue">coordenadas GPS</i> si existen.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Comandos con opciones de EXIFTOOL.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <i className="span-yellow">Exiftool</i> permite el paso de multiples <span className="span-white">parametros</span> para la <i className="span-blue">visualización</i> o <i className="span-blue">modificación</i> de <span className="span-pink">metadatos</span> de algun <span className="span-white">archivo</span>.
            </p>

            <p>
                <b className="span-blue">
                    1. Visualizar todos los metadatos:
                </b>
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "exiftool <nombre-archivo>"
            />

            <p>
                Por <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "exiftool imagen.jpg"
            />

            <p>
                <span className="span-white">Donde</span>:
            </p>

            <Img
                img = {Img_Three}
                alt = {"Imagen 4. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"4. Comando para visualizar todos los metadatos con EXIFTOOL."}
            />

            <p>
                <b className="span-blue">
                    2. Visualizar un campo específico:
                </b>
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "exiftool -<nombre-dato> <nombre-archivo>"
            />

            <p>
                Un <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "exiftool -DateTimeOriginal archivo.jpg"
            />

            <p>
                <span className="span-white">Visualizando:</span>
            </p>

            <Img
                img = {Img_Four}
                alt = {"Imagen 5. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"5. Comando para visualizar un campo con EXIFTOOL."}
            />

            <p>
                <b className="span-blue">
                    3. Mostrar solo el valor sin etiquetas:
                </b>
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "exiftool -s -s -s -<nombre-dato> <nombre-archivo>"
            />

            <p>
                Por <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "exiftool -s -s -s -FileType archivo.jpg"
            />

            <p>
                <span className="span-white">Visualizando:</span>
            </p>

            <Img
                img = {Img_Five}
                alt = {"Imagen 6. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"6. Comando para visualizar metadatos sin etiquetas con EXIFTOOL."}
            />

            <p>
                <b className="span-blue">
                    4. Mostrar también el grupo (EXIF, IPTC, XMP):
                </b>
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "exiftool -G <nombre-archivo>"
            />

            <p>
                Por <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "exiftool -G archivo.jpg"
            />

            <p>
                <span className="span-white">Visualizando:</span>
            </p>

            <Img
                img = {Img_Six}
                alt = {"Imagen 7. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"7. Comando para visualizar grupos de metadatos con EXIFTOOL."}
            />

            <p>
                <b className="span-yellow">Nota:</b> En <span className="span-yellow">investigaciones forenses</span>, esto permite identificar qué <i className="span-blue">software</i> o <i className="span-blue">dispositivo</i> creó el <span className="span-white">archivo</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Escritura y modificación de metadatos con EXIFTOOL.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <i className="span-yellow">ExifTool</i> <span className="span-pink">NO</span> solo permite <i className="span-blue">leer</i>, sino también <span className="span-pink">editar</span> <span className="span-white">metadatos</span>.
            </p>

            <p>
                <b className="span-yellow">Nota:</b> En <i className="span-yellow">Kali Linux</i>, por seguridad, cada vez que se <span className="span-pink">modifican</span> metadatos se guarda una <span className="span-pink">copia de respaldo</span> con la extensión <i className="span-white">_original</i>.
            </p>

            <p>
                <b className="span-blue">
                    1. Cambiar el nombre del autor:
                </b>
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -Artist="<nombre-nuevo-autor>" <nombre-archivo>`}
            />

            <p>
                Por <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -Artist="Manuel L." archivo.jpg`}
            />

            <p>
                <span className="span-white">Donde</span>:
            </p>

            <Img
                img = {Img_Seven}
                alt = {"Imagen 8. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"8. Comando para modificar nombre de autor."}
            />

            <p>
                <b className="span-blue">
                    2. Cambiar la fecha y hora de captura:
                </b>
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -DateTimeOriginal="<año:mes:dia> <hora:minuto:segundo>" <nombre-archivo>`}
            />

            <p>
                Un comando de <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -DateTimeOriginal="2025:09:11 10:00:00" archivo.jpg`}
            />

            <p>
                <span className="span-white">Donde</span>:
            </p>

            <Img
                img = {Img_Eight}
                alt = {"Imagen 9. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"9. Comando para modificar la fecha y hora con EXIFTOOL."}
            />

            <p>
                <b className="span-blue">
                    3. Eliminar un campo específico:
                </b>
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -<nombre-campo>= <nombre-archivo>`}
            />

            <p>
                Por <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -Artist= archivo.jpg`}
            />

            <p>
                <span className="span-white">Donde</span>:
            </p>

            <Img
                img = {Img_Nine}
                alt = {"Imagen 10. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"10. Comando para eliminar un campo con EXIFTOOL."}
            />
            
            <p>
                <b className="span-blue">
                    4. Eliminar todos los metadatos (dejando el archivo limpio):
                </b>
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -all= <nombre-archivo>`}
            />

            <p>
                un <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -all= archivo.jpg`}
            />

            <p>
                <span className="span-white">Visualizando</span>:
            </p>

            <Img
                img = {Img_Ten}
                alt = {"Imagen 11. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"11. Comando para eliminar todos los campos con EXIFTOOL."}
            />

            <p>
                <b className="span-yellow">Nota:</b> Esto es muy usado en <span className="span-pink">anonimización</span> de <span className="span-white">archivos</span> antes de publicarlos en <span className="span-pink">internet</span>. <span className="span-pink">Eliminando</span> datoa sensibles, dejando los <span className="span-white">datos simples</span> de informacion del <span className="span-white">archivo</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Extracción de información sensible con EXIFTOOL.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Uno de los usos más <span className="span-white">importantes</span> en <span className="span-yellow">ciberseguridad</span> es <span className="span-pink">extraer</span> <span className="span-white">datos sensibles</span> que los usuarios olvidan borrar:
            </p>

            <p>
                <b className="span-blue">
                    1. Obtener las coordenadas GPS de una foto:
                </b>
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -GPSLatitude -GPSLongitude <nombre-archivo>`}
            />

            <p>
                <span className="span-white">Ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -GPSLatitude -GPSLongitude archivo.jpg`}
            />

            <p>
                <b className="span-yellow">Nota: </b>En ocaciones, este tipo de <span className="span-pink">datos sensibles</span>, se <span className="span-white">eliminan</span> por aplicaciones de <span className="span-blue">red sociales</span> o <span className="span-blue">correos</span>.
            </p>

            <p>
                <b className="span-blue">
                    2. Extraer la miniatura oculta dentro de una imagen:
                </b>
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -b -ThumbnailImage <nombre-archivo> > <nombre-nuevo-archivo>`}
            />

            <p>
                Por <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -b -ThumbnailImage archivo.jpg > miniatura.jpg`}
            />

            <p>
                <span className="span-white">
                    Visualizando
                </span>:
            </p>

            <Img
                img = {Img_Eleven}
                alt = {"Imagen 12. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"12. Comando para obtener la miniatura con EXIFTOOL."}
            />

            <p>
                <b className="span-yellow">Nota: </b> Esto puede <span className="span-white">revelar</span> la <span className="span-pink">ubicación real</span> o una <span className="span-pink">imagen en baja calidad</span> que podría ser <span className="span-white">evidencia</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Procesamiento masivo de archivos con EXIFTOOL.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <i className="span-yellow">ExifTool</i> también permite <span className="span-pink">analizar</span> <span className="span-white">carpetas completas</span>:
            </p>

            <p>
                <b className="span-blue">
                    1. Leer metadatos de todos los archivos JPG en la carpeta:
                </b>
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool *.<extension-archivos>`}
            />

            <p>
                Por <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool *.jpg`}
            />

            <p>
                <b className="span-yellow">Nota:</b> Este <span className="span-white">comando</span> leera los <span className="span-pink">metadatos</span> de manera <span className="span-white">recursiva</span> de <span className="span-pink">TODOS</span> los archivos dentro del <span className="span-white">directorio</span> donde se ejecuta el <span className="span-white">comando</span>, que coincidan con la <span className="span-pink">extensión</span> de archivo señalada.
            </p>

            <p>
                <b className="span-blue">
                    2. Analizar recursivamente subcarpetas:
                </b>
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -r <ruta-de-carpeta>`}
            />
            
            <p>
                Por <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -r /imagenes`}
            />

            <p>
                <b className="span-blue">
                    3. Exportar resultados en formato JSON (ideal para análisis automatizado):
                </b>
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -json *.<extension-archivos> > <nombre-nuevo-archivo>.json`}
            />

            <p>
                Por <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -json *.jpg > salida.json`}
            />

            <p>
                <span className="span-white">Visualizando</span>:
            </p>

            <Img
                img = {Img_Twelve}
                alt = {"Imagen 13. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"13. Comando para obtener metadatos en archvo .json con EXIFTOOL."}
            />

            <p>
                <b className="span-blue">
                    4. Exportar resultados en CSV (útil para hojas de cálculo):
                </b>
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -csv *.<extension-archivos> > <nombre-nuevo-archivo>.csv`}
            />

            <p>
                Por <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool -csv *.jpg > salida.csv`}
            />

            <p>
                <span className="span-white">Visualizando</span>:
            </p>

            <Img
                img = {Img_Thirteen}
                alt = {"Imagen 14. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"14. Comando para obtener metadatos en archvo .csv con EXIFTOOL."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Renombrado automático según metadatos con EXIFTOOL.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <i className="span-yellow">ExifTool</i> permite <span className="span-pink">renombrar</span> <span className="span-white">archivos</span> basándose en sus propios <span className="span-pink">metadatos</span>.
            </p>

            <p>
                Por <span className="span-white">ejemplo</span>, para <span className="span-pink">renombrar</span> <span className="span-white">fotos</span> de acuerdo a la <span className="span-white">fecha de captura</span>:
            </p>
            
            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`exiftool '-FileName<DateTimeOriginal' -d %Y-%m-%d_%H-%M-%S.jpg *.jpg`}
            />

            <p>
                <span className="span-white">Donde</span>:
            </p>

            <Img
                img = {Img_Fourteen}
                alt = {"Imagen 15. EXIFTOOL."}
                title = {"Descripcción de imagen."}
                text = {"15. Comando para modificar nombre de archivo a fecha de creación con EXIFTOOL."}
            />

            <p>
                <b className="span-yellow">Nota:</b> Esto es útil en el manejo de <span className="span-pink">grandes volúmenes </span>de <span className="span-white">imágenes</span>, como en un caso de <span className="span-yellow">investigación forense</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Recursos estra de EXIFTOOL.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">Página oficial</span> de <i className="span-yellow">ExifTool</i>: <a className="span-white" href="https://exiftool.org" target="_blank"><span className="span-white">https://exiftool.org</span></a>
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Lista completa</span> de <span className="span-white">etiquetas</span> soportadas: <a className="span-white" href="https://exiftool.org/TagNames/" target="_blank"><span className="span-white">https://exiftool.org/TagNames/</span></a>
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-white">Manual</span> en <span className="span-pink">consola</span>:
                    </p>

                    <Comand
                        funcionNotificacion={props.funcionNotificacion}
                        notifications={props.notifications}
                        code={`man exiftool`}
                    />

                </li>
            </ul>

            

        </>
    );
}